import React, { Component } from "react";

import { Row, Col, Card, CardBody, FormGroup, Button,  Label, Container, Spinner } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { BaseUrl } from "../../../helpers/Baseurl"


class AddDistrict extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      country:null,
      selectedCountry: { label: "Select Country", value: null },
      breadcrumbItems: [
        { title: "Countries", link: "/manage-countries" },
        { title: "Add New State", link: "#" },
      ],
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
  }
	

    this.handleSubmit = this.handleSubmit.bind(this);    

  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/manage-countries')
  }

  componentDidMount(){
    this.loadState()
  }

  loadState(){
    const id =this.props.match.params.id
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        };
        fetch(`${BaseUrl}/api/locations/location/states/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                      res.json()
                      .then(
                          (data) =>{  
                            console.log(data, "---data")
                            toastr.error("Something Went Wrong", "") 
                            this.props.history.push(`/manage-countries`)
                          }
                            
                      )
                  }
                  else{
                      res.json()
                      .then(
                          (data) =>{
                            this.setState({country:data})
                            this.setState({district: data.district})
                            this.setState({breadcrumbItems: [
                                { title: "Countries", link: "/manage-countries" },
                                { title: `Edit ${data.name}`, link: `/state/${data.id}` },
                                { title: "Add New District", link: `#` },

                              ],})
                          }
                      )
                  }    
              }
          )

  }


  
  async handleSubmit(e, values) {
    const id =this.props.match.params.id
    const {district, country} = this.state
    let districts = []
    for (let i=0; i< district.length; i++){
        districts.push(district[i].id)
    }

    this.setState({ loading: true })

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values)
        };
    fetch(`${BaseUrl}/api/locations/location/districts/`,requestOptions)
    .then(res => 
        {if(res.status >= 400){
            res.json()
            .then(
                (data) =>{  
                    console.log(data, "---data")
                    toastr.error("Something Went Wrong", "") 
                    this.setState({ loading: false })
                }
                    
            )
        }
        else{
            res.json()
            .then(
                (data) =>{
                    districts.push(data.id)
                    let statedata = {
                        "name": values.name,
                        "country": country.country.id,
                        "district": districts  }
                    const requestOptions = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(statedata)
                        };
                        fetch(`${BaseUrl}/api/locations/location/states/`,requestOptions)
                            .then(res => 
                                {if(res.status >= 400){
                                    res.json()
                                    .then(
                                        (data) =>{  
                                            console.log(data, "---data")
                                            toastr.error("Something Went Wrong", "") 
                                            this.setState({ loading: false })
                                        }
                                            
                                    )
                                }
                                else{
                                    res.json()
                                    .then(
                                        (data) =>{
                                        toastr.success(`District Added Successfully`, "") 
                                        this.props.history.push(`/state/${id}`)
                                        }
                                    )
                                }    
                            }
                        )
                        
                    }
                
            )
                }    
            }
        )
      
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Add New District" breadcrumbItems={this.state.breadcrumbItems} />
            <AvForm className="needs-validation" onValidSubmit={this.handleSubmit} >
              <Row>
                <Col xl="6">
                  <Card>
                    <CardBody> 
                      <h4 className="card-title">Add New District</h4>
                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <Label className="form-label" htmlFor="name">District Name</Label>
                              <AvField
                                name="name"
                                placeholder="District Name"
                                type="text"
                                errorMessage="Enter District Name"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="name"
                                
                              />
                            </div>
                          </Col> 
                        </Row>
                                          
                        <FormGroup className="mb-0">
                          {this.state.loading?(
                            <Spinner className="me-2 mt-2" color="primary" />
                          ):(
                            <div>
                        
                          <Button type="submit" color="primary" className="me-1">
                            Submit
                        </Button>{" "}
                          <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                            Cancel
                        </Button>
                        </div>
                          )}
                        
                        
                      </FormGroup>      

                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default AddDistrict;



    